







































import { Component, Mixins, Prop} from "vue-property-decorator";
import { Patient } from "../../../domain/patient";
import { PatientViewerMixin } from "./mixins";

@Component
export default class SimplePatientViewer extends Mixins(PatientViewerMixin) {
  @Prop()
  patient: Patient;

  @Prop({ default: true })
  shouldShowDetail: boolean;

  get sexIcon(): string {
    return "patient-viewer-sex-icon patient-viewer-sex-icon-" + this.sexKey.toLowerCase();
  }
}
